import {AxiosInstance} from "../api/AxiosInstance";

export const langScheme = async (lang) => {
  try {
    const response = await AxiosInstance.get(`/api/lang/sch?ln=${lang}`)
    return response.data
  } catch (error) {
    throw error.response?.data || "Failed get scheme"
  }
}

export const updateLangScheme = async (payload) => {
  try {
    const response = await AxiosInstance.post(`/api/actualizar/idioma`, payload)
    return response
  } catch (error) {
    throw error.response?.data || "Failed update scheme"
  }
}